import DashboardStore from "./Dashboard/DashboardStore";
import AIAgentStore from "./AIAgent/AIAgentStore";

const administrationStoreList = [
    { name: "dashboardStore", store: DashboardStore },
    { name: "aiAgentStore", store: AIAgentStore },
];

export default administrationStoreList;
